import React, { ChangeEvent, JSX } from 'react';
import './app-radio-button.scss';

export interface AppBaseItem {
  value: string;
  label: string;
}

export interface AppRadioButtonConfig extends AppBaseItem {
  description?: string;
  disabled?: boolean;
  renderLabelFirst?: boolean;
  valid?: boolean;
}

export interface AppLayeredRadioButtonConfig extends AppBaseItem {
  description?: string;
  disabled?: boolean;
  renderLabelFirst?: boolean;
  valid?: boolean;
  subLayerComponent?: JSX.Element;
  onUnmountSubLayer?: () => void;
}

export interface AppRadioButtonProps extends AppRadioButtonConfig {
  checked?: boolean;
  onSelect?: (e: ChangeEvent<HTMLInputElement>) => void;
  layered?: boolean;
  readonly?: boolean;
}

export const AppRadioButton = (props: AppRadioButtonProps) => {
  const { renderLabelFirst, label, value, checked = false, disabled = false, readonly = false, description, onSelect, valid = true } = props;

  return (
    <div>
      <label className={`container ${disabled ? ' disabled' : ''}`}>
        {renderLabelFirst && label}
        <input type='radio' value={value} checked={checked} readOnly={readonly} disabled={disabled} onChange={onSelect} />
        <span className={`checkmark ${valid ? '' : ' checkmark-error'}`} />
        {!renderLabelFirst && <span className='label' dangerouslySetInnerHTML={{ __html: label }}></span>}
      </label>
      {description && <div className='description'>{description}</div>}
    </div>
  );
};
